import { call, put, takeLatest } from 'redux-saga/effects';
import { isArray } from 'lodash';
import { bankCards, deleteCard } from '../../services/API';
import { actionTypes, requestFetchFailure, requestFetchSuccess } from './actions';
import {
  requestDeleteFailure,
  requestDeleteSuccess,
} from 'modules/Payment/redux/bankCards/actions';
import { newCardObject } from 'modules/Payment/components/BankCards/constants';

function* fetchBankCards() {
  const response = yield call(bankCards);
  if (response.isOk) {
    const cardsArray = isArray(response.data) ? [...response.data, newCardObject] : [];
    return yield put(requestFetchSuccess(cardsArray));
  }

  return yield put(requestFetchFailure(response.error));
}

function* deleteBankCard(action) {
  const response = yield call(deleteCard, action.payload);
  if (response.isOk) {
    return yield put(requestDeleteSuccess(action.payload));
  }

  return yield put(requestDeleteFailure(response.error));
}

function* setDefaultBankCard() {}

export default function* BankCardsSaga() {
  yield takeLatest(actionTypes.FETCH_BANK_CARDS_START, fetchBankCards);
  yield takeLatest(actionTypes.DELETE_BANK_CARD_START, deleteBankCard);
  yield takeLatest(actionTypes.SET_DEFAULT_BANK_CARD_START, setDefaultBankCard);
}
